const NotificationsEndpointFetchAllRequestHttpQueryParams = (request) => {
    return {
        patient_id: request.patient_id,
        page_size: request.pagination?.page_size,
        page_token: request.pagination?.page_token,
    };
};
export const NotificationsEndpoint = (makeRequest) => {
    return {
        // Fetch all notifications using pagination
        fetchAll(params, options) {
            return makeRequest('GET', '/v1/customer_support/notifications', NotificationsEndpointFetchAllRequestHttpQueryParams(params), options);
        },
        // Mark all currently unread notifications as read
        readAllCurrentlyUnread(params, options) {
            return makeRequest('PUT', '/v1/customer_support/notifications/read_all_currently_unread', params, options);
        },
    };
};
//# sourceMappingURL=notifications_endpoint.js.map